export const GetLayerFieldData = Symbol('GetLayerFieldData');
export const SetLayerFieldData = Symbol('SetLayerFieldData');
